import axios from 'utils/axios';

export async function fetchTwilioAccessToken() {
    try {
        const response = await axios.post('/api/org-id/{orgId}/clinic-id/{clinicId}/twilio/access-token');
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}

// `clinicId` is passed explicitly because the axios interceptor's {clinicId}
// substitution only fires on /clinic/... paths, and the poll outlives that.
export async function fetchGeneratedCareSessionNote(clinicId, callSid) {
    return axios.get(`/api/org-id/{orgId}/clinic-id/${clinicId}/twilio/outbound-call/${callSid}/generated-note`);
}

// Mid-call consent denial: the server stops the Twilio recording and discards
// the partial recording/transcript, so no note is generated. Only valid while
// the call is in progress — the server responds 409 once the call has ended.
export async function denyRecordingConsent(clinicId, callSid) {
    return axios.post(`/api/org-id/{orgId}/clinic-id/${clinicId}/twilio/outbound-call/${callSid}/deny-recording-consent`);
}

// Lightweight, role-agnostic read of a clinic's outbound-calling config. Unlike the
// clinic-settings endpoint, the global onPostAuth hook only enforces org/clinic ownership
// from the URL — any authenticated user with access to the clinic can call it.
// Response: { enabled: boolean, callerId: string | null }
export async function getOutboundCallingConfig(clinicId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/${clinicId}/twilio/outbound-calling-config`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
